const initialState = { name: null, version: null, os: null };

/**
 * browserdetect reducer.
 * @function browserdetect
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function browserdetect(state = initialState, action = {}) {
  return state;
}
